(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["customer-video-marquee"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const marquee = document.querySelector('.customer-video-marquee');
    if (!marquee) return;

    const track = marquee.querySelector('.customer-video-marquee__track');
    const toggle = marquee.querySelector('.customer-video-marquee__toggle');
    if (!track || !toggle) return;

    let paused = false;

    const setPaused = (value) => {
      paused = value;
      track.classList.toggle('customer-video-marquee__track--paused', paused);
      toggle.setAttribute('aria-pressed', String(paused));
      toggle.textContent = paused ? '▶' : '⏸';
      toggle.setAttribute('aria-label', paused ? 'Reanudar carrusel de videos' : 'Pausar carrusel de videos');
    };

    toggle.addEventListener('click', () => setPaused(!paused));
    marquee.addEventListener('mouseenter', () => track.classList.add('customer-video-marquee__track--hover-paused'));
    marquee.addEventListener('mouseleave', () => track.classList.remove('customer-video-marquee__track--hover-paused'));
    marquee.addEventListener('focusin', () => track.classList.add('customer-video-marquee__track--hover-paused'));
    marquee.addEventListener('focusout', () => track.classList.remove('customer-video-marquee__track--hover-paused'));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.product-faq__question').forEach((button) => {
      button.addEventListener('click', () => {
        const expanded = button.getAttribute('aria-expanded') === 'true';
        const panel = document.getElementById(button.getAttribute('aria-controls'));
        button.setAttribute('aria-expanded', String(!expanded));
        panel.classList.toggle('product-faq__answer--open', !expanded);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-add-to-cart"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const bar = document.querySelector('.sticky-atc');
    if (!bar) return;

    const realSubmit = document.querySelector('[id^="ProductSubmitButton-"]');
    if (!realSubmit) return;

    const stickyButton = bar.querySelector('.sticky-atc__button');
    const stickyLabel = bar.querySelector('.sticky-atc__button-label');
    const stickyPrice = bar.querySelector('.sticky-atc__price');

    stickyButton.addEventListener('click', () => {
      if (!realSubmit.disabled) realSubmit.click();
    });

    const observer = new IntersectionObserver(
      (entries) => {
        const isVisible = !entries[0].isIntersecting;
        bar.hidden = !isVisible;
        bar.classList.toggle('sticky-atc--visible', isVisible);
      },
      { threshold: 0 }
    );
    observer.observe(realSubmit);

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        const variant = event.data.variant;
        const html = event.data.html;
        if (!variant) return;

        stickyButton.disabled = !variant.available;
        stickyLabel.textContent = variant.available
          ? stickyLabel.dataset.addToCartLabel
          : stickyLabel.dataset.soldOutLabel;

        const priceSource = html.getElementById(`price-${event.data.sectionId}`);
        if (priceSource && stickyPrice) {
          const isOnSale = priceSource.classList.contains('price--on-sale');
          const priceItem = priceSource.querySelector(
            isOnSale ? '.price__sale .price-item--sale' : '.price__regular .price-item--regular'
          );
          if (priceItem) stickyPrice.textContent = priceItem.textContent.trim();
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
